import messageEnums from 'enums/messages';
import { MESSAGE_TYPE } from 'GladlySidekickConstants';

export default function mapMessageType(type) {
  switch (type) {
    case messageEnums.SUB_TYPES.IMAGE:
      return MESSAGE_TYPE.IMAGE;
    case messageEnums.SUB_TYPES.FILE:
      return MESSAGE_TYPE.FILE;
    case messageEnums.SUB_TYPES.TEXT:
      return MESSAGE_TYPE.TEXT;
  }

  return '';
}
